module.exports = __webpack_public_path__ + "img/logoInc.5cb959a0.png";